import React, { useState } from 'react';
import SwingDashboard from './SwingDashboard';
import SwingScanner from './SwingScanner';
import SwingPortfolio from './SwingPortfolio';
import SwingJournal from './SwingJournal';
import SwingAlerts from './SwingAlerts';
import SwingRebalance from './SwingRebalance';
import SwingSettings from './SwingSettings';

const TABS = [
  { id: 'dashboard', label: '📊 Dashboard' },
  { id: 'scanner',   label: '🔍 Scanner' },
  { id: 'portfolio', label: '💼 Portfolio' },
  { id: 'journal',   label: '📒 Journal' },
  { id: 'alerts',    label: '🔔 Alerts' },
  { id: 'rebalance', label: '⚖️ Rebalance' },
  { id: 'settings',  label: '⚙️ Settings' },
];

export default function SwingTrader() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderTab = () => {
    switch (activeTab) {
      case 'dashboard': return <SwingDashboard onNavigate={setActiveTab} />;
      case 'scanner':   return <SwingScanner />;
      case 'portfolio': return <SwingPortfolio />;
      case 'journal':   return <SwingJournal />;
      case 'alerts':    return <SwingAlerts />;
      case 'rebalance': return <SwingRebalance />;
      case 'settings':  return <SwingSettings />;
      default:          return <SwingDashboard onNavigate={setActiveTab} />;
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ margin: '0 0 4px 0', fontSize: 22, fontWeight: 700 }}>📈 Swing Trader</h2>
        <p style={{ margin: 0, color: '#888', fontSize: 13 }}>NSE Nifty 500 · 1–3 month holding horizon · Signals only (manual execution)</p>
      </div>

      {/* Inner tab bar */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, flexWrap: 'wrap', borderBottom: '1px solid #333', paddingBottom: 0 }}>
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setActiveTab(t.id)}
            style={{
              background: 'none',
              border: 'none',
              borderBottom: activeTab === t.id ? '2px solid #4CAF50' : '2px solid transparent',
              color: activeTab === t.id ? '#4CAF50' : '#aaa',
              padding: '8px 16px',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: activeTab === t.id ? 600 : 400,
              marginBottom: -1,
              transition: 'all 0.15s',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {renderTab()}
    </div>
  );
}
